<mat-card
  @enterFadeIn
  class="min-w-72 rounded-lg border border-gray-200 bg-neutral-98 p-3 shadow-sm">
  <div class="flex items-center justify-between px-2">
    <h3 class="text-lg font-medium text-primary-60">Fichaje</h3>
    <div class="flex items-center gap-2">
      <mat-icon
        class="material-symbols-outlined text-neutral-80 transition-colors duration-300 ease-in-out hover:text-primary-60"
        [matTooltip]="infoTooltip"
        matTooltipClass="qaroni-info-tooltip">
        info
      </mat-icon>
      <div
        [matTooltip]="indicatorLabel"
        class="relative flex items-center justify-center">
        @if (!!journey?.isOpen) {
          <div
            [class]="indicatorColor"
            class="absolute h-3 w-3 animate-ping rounded-full opacity-25 transition-colors duration-500 ease-in-out"></div>
        }
        <div
          [class]="indicatorColor"
          class="h-3 w-3 rounded-full transition-colors duration-500 ease-in-out"></div>
      </div>
    </div>
  </div>

  <mat-card-content class="flex w-full items-center justify-between gap-1 py-3">
    <div class="flex-1 text-center">
      <span class="text-6xl font-light leading-none">
        {{ journey?.totalJourney | totalMinutesFormat }}
      </span>
      <p class="font-light" i18n>Jornada de hoy</p>
    </div>
  </mat-card-content>

  <mat-card-actions class="m-0 flex justify-center py-3">
    <div class="flex flex-col gap-2" [matTooltip]="tooltipText">
      @if (allowBreakCheck && journey?.isOpen && buttonBreak) {
        <button
          mat-flat-button
          [color]="buttonBreak?.colorButton"
          class="qaroni-rounded-button"
          (click)="onCheckBreak()"
          [disabled]="(isLoading$ | async) || !enableCheck">
          @if ((isLoading$ | async) === false) {
            <ng-container>
              <mat-icon class="me-1">{{ buttonBreak?.iconButton }}</mat-icon>
              {{ buttonBreak?.textButton }}
            </ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="loading" />
          }
        </button>
      }
      <button
        mat-flat-button
        [color]="buttonWork?.colorButton"
        class="qaroni-rounded-button"
        (click)="onCheckWork()"
        [disabled]="(isLoading$ | async) || !enableCheck">
        @if ((isLoading$ | async) === false) {
          <ng-container>
            <mat-icon class="me-1">{{ buttonWork?.iconButton }}</mat-icon>
            {{ buttonWork?.textButton }}
          </ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="loading" />
        }
      </button>
    </div>
  </mat-card-actions>
</mat-card>

<ng-template #loading>
  <mat-spinner [diameter]="30" class="mx-auto" />
</ng-template>
